import { AlertCircleFilled } from '@creditornot/cb-icons';
import { colors } from '@creditornot/cb-ingredients';
import { Tag, TagVariant } from '@creditornot/cb-tag';
import React from 'react';
import styled from 'styled-components';

type TabCountIconProps = {
  count: number;
  variant: 'error' | 'active' | 'info';
};

const StyledAlertCircleFilled = styled(AlertCircleFilled)`
  display: block;
  width: 14px;
  fill: ${colors.strawberry100};
`;

const StyledTag = styled(Tag)`
  margin-inline-start: 4px;
`;

const Container = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

const propsVariantToTagBackground: Record<TabCountIconProps['variant'], TagVariant> = {
  error: 'lightRed',
  active: 'lightBlue',
  info: 'lightBlack',
};

export const TabCountIcon = ({ count, variant }: TabCountIconProps) => {
  if (variant === 'error' && count < 1) {
    return null;
  }

  return (
    <StyledTag iconPosition="start" size="small" variant={propsVariantToTagBackground[variant]}>
      <Container>
        {variant === 'error' && <StyledAlertCircleFilled />}
        {count}
      </Container>
    </StyledTag>
  );
};
